import React, { FC } from 'react';
import { Divider, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { usePlanningTemplate } from 'hooks/usePlanningTemplate';
import { useValueTemplate } from 'hooks/useValueTemplate';

type ProductionTemplateFilterProps = {
    templateType: 'plan' | 'value';
    value?: string;
    onSelect: (value: string) => void;
};

const ProductionTemplateFilter: FC<ProductionTemplateFilterProps> = ({ templateType, value, onSelect }) => {
    const { t: translate } = useTranslation('lab-settings');
    const { planningTemplates } = usePlanningTemplate();
    const { valueTemplates } = useValueTemplate();

    const templates = (templateType === 'plan' ? planningTemplates : valueTemplates) as { _id: string; name: string }[];
    const label =
        templateType === 'plan'
            ? translate('lab-settings:PRODUCTION_PLAN_TEMPLATE')
            : translate('lab-settings:PRODUCTION_VALUE_TEMPLATE');

    return (
        <FormControl margin="dense" fullWidth>
            <InputLabel>{label}</InputLabel>
            <Select label={label} value={value || 'ALL'} onChange={(event) => onSelect(event.target.value)}>
                <MenuItem value="ALL">{translate('lab-settings:ALL_PRODUCTION_TEMPLATES')}</MenuItem>
                <MenuItem value="ACTIONS_WITHOUT_PRODUCTION_TEMPLATE">
                    {translate('lab-settings:ACTIONS_WITHOUT_PRODUCTION_TEMPLATE')}
                </MenuItem>
                <Divider />
                {templates.map((t) => (
                    <MenuItem key={t._id} value={t._id}>
                        {t.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ProductionTemplateFilter;
